import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { ExportTemplateItemDownloadUrlResponse } from '@utils/types/organization/export-template-item.ts';
import { BaseError } from '@utils/types/shared/base.ts';

type DownloadParams = {
  itemId: number;
  expirySeconds?: number;
};

export const useGetExportTemplateItemDownload = () => {
  const getDownloadUrl = async ({
    itemId,
    expirySeconds = 3600
  }: DownloadParams): Promise<ExportTemplateItemDownloadUrlResponse> => {
    const url = GET_URL(
      itemId.toString(),
      expirySeconds.toString()
    ).exportTemplateItemDownload;
    const { data } =
      await Axios.get<ExportTemplateItemDownloadUrlResponse>(url);
    return data;
  };

  return useMutation<
    ExportTemplateItemDownloadUrlResponse,
    AxiosError<BaseError>,
    DownloadParams
  >(getDownloadUrl, {
    useErrorBoundary: false
  });
};
